const Mission: React.FC = () => {
	return (
		<section className="mb-16">
			<h2 className="text-3xl font-semibold mb-6">ミッション・ビジョン</h2>
			<div className="grid md:grid-cols-2 gap-8">
				<div className="bg-white p-6 rounded-lg shadow-md">
					<h3 className="text-xl font-semibold mb-4">ミッション</h3>
					<p className="text-gray-700">
						地域の人々が気軽に学び、成長できるコミュニティを作り、
						大船渡から新しい価値を生み出すきっかけを創造します。
					</p>
				</div>
				<div className="bg-white p-6 rounded-lg shadow-md">
					<h3 className="text-xl font-semibold mb-4">ビジョン</h3>
					<p className="text-gray-700">
						2025年までに、100人以上の地域の方々が
						新しいスキルを身につけ、それを活かして
						地域に貢献できる環境を実現します。
					</p>
				</div>
			</div>
		</section>
	);
};

export default Mission;
